import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
const IoMdSearch = require("react-icons/io").IoMdSearch;

const Presiden = () => {
  const [presidenList, setPresidenList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(""); // <-- state untuk search
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(null);

  const fetchPresiden = async (page: number = 1, searchQuery: string = "") => {
    setLoading(true);
    try {
      const token = Cookies.get("token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/presiden?page=${page}&search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPresidenList(res.data.data);
      setCurrentPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error("Gagal ambil data presiden:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPresiden();
  }, []);

  // 🔍 Ketika user mengetik di search bar
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);

    // debounce 500ms biar gak spam request
    if (typingTimeout) clearTimeout(typingTimeout);
    const timeout = setTimeout(() => {
      fetchPresiden(1, value);
    }, 500);
    setTypingTimeout(timeout);
  };

  // 🔍 Klik tombol cari manual (opsional)
  const handleSearchSubmit = () => {
    fetchPresiden(1, search);
  };

  return (
    <div className="overflow-x-auto mt-7">
      <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-3">
        <h2 className="text-xl font-bold">Daftar Pejabat</h2>

        <div className="flex items-center gap-3 w-full md:w-auto">
          {/* Input Search */}
          <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden w-full md:w-64">
            <input type="text" placeholder="Search..." value={search} onChange={handleSearchChange} className="flex-1 px-3 py-2 outline-none" />
            <button onClick={handleSearchSubmit} className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-3 font-semibold">
              <IoMdSearch />
            </button>
          </div>

          <Link to="/dashboard/presiden/tambah">
            <div className="border border-black2 rounded-lg px-3 py-2 text-black2 hover:bg-gray-100">Tambah Data Pejabat</div>
          </Link>
        </div>
      </div>

      {/* Table */}
      <table className="min-w-full border border-gray-300 text-sm md:text-base rounded-lg">
        <thead className="bg-primary text-black2">
          <tr>
            <th className="p-2 text-left">No</th>
            <th className="p-2 text-left">Nama</th>
            <th className="p-2 text-left">Foto</th>
            <th className="p-2 text-left">Jabatan</th>
            <th className="p-2 text-left">Bidang</th>
            <th className="p-2 text-left">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={6} className="text-center p-4">
                <div className="flex justify-center items-center h-40">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
                </div>
              </td>
            </tr>
          ) : presidenList.length > 0 ? (
            presidenList.map((item: any, index: any) => (
              <tr key={item.id} className="border-b hover:bg-gray-100">
                <td className="p-2">{index + 1}</td>
                <td className="p-2">{item.nama?.length > 20 ? item.nama.slice(0, 20) + "..." : item.nama}</td>
                <td className="p-2">
                  <img src={item.foto} alt={item.nama} className="w-20 h-24 object-cover rounded" />
                </td>
                <td className="p-2">{item.jabatan?.length > 12 ? item.jabatan.slice(0, 12) + "..." : item.jabatan}</td>
                <td className="p-2">{item.bidang?.length > 12 ? item.bidang.slice(0, 12) + "..." : item.bidang}</td>

                <td className="p-2 text-blue-600">
                  <Link to={`/dashboard/presiden-detail/${item.id}`}>Detail</Link>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center p-4">
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-end gap-4 items-center mt-4">
        <button className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50" onClick={() => fetchPresiden(currentPage - 1, search)} disabled={currentPage === 1 || loading}>
          Prev
        </button>
        <span>
          Halaman {currentPage} dari {lastPage}
        </span>
        <button className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50" onClick={() => fetchPresiden(currentPage + 1, search)} disabled={currentPage === lastPage || loading}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Presiden;
